export const isExpandableSignedUrlPreview = (contentType?: string) => {
  const normalizedContentType = contentType?.toLowerCase() ?? '';
  return (
    normalizedContentType.includes('xml') ||
    normalizedContentType.includes('html') ||
    normalizedContentType.startsWith('text/')
  );
};

const LINE_LEADING_BULLET_PLACEHOLDER_PATTERN = /^(\s*)\?\s+/gm;
const REPLACEMENT_CHARACTER_PATTERN = /\uFFFD/;
const WINDOWS_1252_CONTROL_CHARACTER_PATTERN = /[\u0080-\u009f]/;
const WINDOWS_1252_CONTROL_CHARACTER_MAP: Record<string, string> = {
  '\u0080': '€',
  '\u0082': '‚',
  '\u0083': 'ƒ',
  '\u0084': '„',
  '\u0085': '…',
  '\u0086': '†',
  '\u0087': '‡',
  '\u0088': 'ˆ',
  '\u0089': '‰',
  '\u008a': 'Š',
  '\u008b': '‹',
  '\u008c': 'Œ',
  '\u008e': 'Ž',
  '\u0091': '‘',
  '\u0092': '’',
  '\u0093': '“',
  '\u0094': '”',
  '\u0095': '•',
  '\u0096': '–',
  '\u0097': '—',
  '\u0098': '˜',
  '\u0099': '™',
  '\u009a': 'š',
  '\u009b': '›',
  '\u009c': 'œ',
  '\u009e': 'ž',
  '\u009f': 'Ÿ',
};

const getCharset = (contentType?: string) =>
  contentType
    ?.match(/charset=([^;\s]+)/i)?.[1]
    ?.trim()
    .toLowerCase();

const decodeWithCharset = (bytes: ArrayBuffer, charset: string) => {
  try {
    return new TextDecoder(charset).decode(bytes);
  } catch {
    return new TextDecoder('utf-8').decode(bytes);
  }
};

const normaliseWindows1252ControlCharacters = (value: string) =>
  value.replace(
    WINDOWS_1252_CONTROL_CHARACTER_PATTERN,
    (character) => WINDOWS_1252_CONTROL_CHARACTER_MAP[character] ?? character,
  );

export const normalisePreviewTextArtifacts = (value: string) =>
  value.replace(LINE_LEADING_BULLET_PLACEHOLDER_PATTERN, '$1• ');

export const decodeSignedUrlPreviewText = (
  bytes: ArrayBuffer,
  contentType?: string,
) => {
  const charset = getCharset(contentType);
  if (charset) {
    return normalisePreviewTextArtifacts(
      normaliseWindows1252ControlCharacters(decodeWithCharset(bytes, charset)),
    );
  }

  const utf8Text = decodeWithCharset(bytes, 'utf-8');
  if (
    !REPLACEMENT_CHARACTER_PATTERN.test(utf8Text) &&
    !WINDOWS_1252_CONTROL_CHARACTER_PATTERN.test(utf8Text)
  ) {
    return normalisePreviewTextArtifacts(
      normaliseWindows1252ControlCharacters(utf8Text),
    );
  }

  return normalisePreviewTextArtifacts(
    normaliseWindows1252ControlCharacters(
      decodeWithCharset(bytes, 'windows-1252'),
    ),
  );
};
